<template>
    <div class="video-library-wrap">
        <bread-crumb :bread-list="breadList" />

        <div class="video-library-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">视频库</span>
            </div>
            <div class="search-wrap">
                <div class="option-wrap">
                    <div class="option-item">
                        <span class="label">视频名称</span>
                        <el-input placeholder="请输入视频名称"
                                  v-model="selectForm.videoNameOrId"
                                  :style="{width: '240px'}">
                        </el-input>
                    </div>

                    <div class="option-item">
                        <span class="label">创建时间</span>
                        <el-date-picker size="small"
                                        clearable
                                        clear-icon="el-icon-error"
                                        v-model="selectForm.createTime"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="yyyy-mm-dd"
                                        end-placeholder="yyyy-mm-dd"
                                        value-format="yyyy-MM-dd"
                                        :style="{width: '240px'}"
                                        :picker-options="datePickerOptions">
                        </el-date-picker>
                    </div>
                    <div class="select-btn-wrap">
                        <el-button type="primary"
                                   size="small"
                                   @click="searchQuery">查询</el-button>
                        <el-button type="info"
                                   size="small"
                                   plain
                                   @click="resetQuery">重置</el-button>
                    </div>
                </div>
                <div>
                    <el-button size="small"
                               @click="handleUpload">上传视频</el-button>
                </div>
            </div>

            <div class="table-wrap">
                <el-table :data="dataList"
                          stripe
                          v-loading="loading"
                          style="width: 100%">
                    <el-table-column min-width="50px"
                                     label="序号">
                        <template slot-scope="scope">
                            <span>{{  scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="videoId"
                                     min-width="260px"
                                     label="视频ID">
                    </el-table-column>
                    <el-table-column prop="videoName"
                                     min-width="180px"
                                     label="视频名称">
                    </el-table-column>
                    <el-table-column prop="videoSuffix"
                                     min-width="90px"
                                     label="视频格式">
                    </el-table-column>
                    <el-table-column min-width="120px"
                                     label="视频大小">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.videoSize|formatData }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="150px"
                                     label="创建时间">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.createTime|formatDate }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="author"
                                     min-width="100px"
                                     label="上传人员">
                    </el-table-column>
                    <el-table-column min-width="120px"
                                     label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isCompleted">转码成功</span>
                            <span v-else>转码中</span>
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right"
                                     label="操作"
                                     width="160">
                        <template slot-scope="scope">
                            <span @click="handleClick(scope.row.videoId)"
                                  class="link-btn">删除</span>
                            <span @click="handleViewClick(scope.row)"
                                  class="link-btn">预览</span>
                            <span @click="handleCreateClick(scope.row.videoId)"
                                  class="link-btn">生成链接</span>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="handlePageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>

        <el-dialog top="20vh"
                   :visible.sync="videoVisible"
                   :show-close="false"
                   :close-on-click-modal="false"
                   custom-class="video-dialog"
                   width="918px">
            <span slot="title">
                <el-image class="icon-delete"
                          :src="deleteUrl"
                          @click="handleVideoClose">
                </el-image>
            </span>
            <video-player v-if="videoVisible"
                          :video-details="videoDetails"
                          :video-visible="videoVisible" />
        </el-dialog>

        <el-dialog title="生成链接"
                   :visible.sync="isCreateShow"
                   custom-class="group-dialog"
                   width="400px">
            <el-form label-width="40px"
                     class="form-wrap">
                <el-form-item label="链接"
                              prop="name"
                              v-loading="linkLoading">
                    <el-input v-model.trim="linkName"
                              ref="copyLink"
                              :style="{width: '320px'}"
                              readonly
                              size="small"></el-input>
                </el-form-item>
                <div class="dialog-btn-wrap">
                    <el-button size="small"
                               type="info"
                               plain
                               :disabled="linkLoading"
                               @click="createAgain">重新生成</el-button>
                    <el-button size="small"
                               type="primary"
                               @click="copyBtn">复 制</el-button>
                </div>
            </el-form>
        </el-dialog>

        <message-box :dialog-visible="dialogVisible"
                     :id="videoId"
                     warning-text="确认将此视频删除？"
                     @handleConfirm="handleConfirm"
                     @handleClose="handleClose" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import shortcuts from '@/utils/pickerOptions'
import Bus from '@/components/Uploader/js/bus'
import { postVideoList, deleteVideo, createVideoLink } from '@/api/video'
import MessageBox from '@/components/MessageBox'
import VideoPlayer from '@/components/Video'
export default {
    name: 'videoLibrary',
    data () {
        return {
            loading: false,
            dialogVisible: false,
            videoVisible: false,
            breadList: [{ label: '内容管理' }, { label: '视频库' }],
            datePickerOptions: {
                shortcuts: shortcuts
            },
            videoId: '',
            dataList: [],
            videoDetails: {},
            selectForm: {
                videoNameOrId: '',
                createTime: ''
            },
            deleteUrl: require('../../../assets/imgs/delete.png'),
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            },
            linkName: '',
            isCreateShow: false,
            linkLoading: false
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ])
    },
    components: {
        MessageBox,
        VideoPlayer
    },
    filters: {
        formatData (value) {
            if (value) {
                if (value > 1048576000) {
                    return (value / 1048576000).toFixed(2) + ' GB'
                } else if (value > 1024000 && value < 1048576000) {
                    return (value / 1024000).toFixed(2) + ' MB'
                } else if (value < 1024000) {
                    return (value / 1000).toFixed(2) + ' KB'
                }
            } else {
                return ''
            }
        },
        formatDate (value) {
            if (value) {
                return value.substring(0, 16)
            } else {
                return ''
            }
        }
    },
    methods: {
        handleClose () {
            this.dialogVisible = false
        },
        handleVideoClose () {
            this.videoVisible = false
        },
        async handleConfirm () {
            this.dialogVisible = false
            this.loading = true
            const { state } = await deleteVideo(this.videoId)
            if (state === 200) {
                this.$message({
                    message: '删除视频成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.query(this.page.current)
            }
        },
        searchQuery () {
            this.query(1)
        },
        resetQuery () {
            this.selectForm.videoNameOrId = ''
            this.selectForm.createTime = ''
            this.query(1)
        },
        handlePageChange (val) {
            this.query(val)
        },
        query (val) {
            this.page.current = val
            this.queryList()
        },
        handleClick (videoId) {
            this.videoId = videoId
            this.dialogVisible = true
        },
        handleViewClick (row) {
            this.videoDetails = row
            this.videoVisible = true
        },
        handleCreateClick (videoId) {
            this.isCreateShow = true
            this.videoId = videoId
            this.createAgain()
        },
        // 复制
        copyBtn () {
            let copyText = this.$refs.copyLink
            copyText.select()
            document.execCommand('Copy')
        },
        // 生成链接
        async createAgain () {
            this.linkLoading = true
            const { state, results } = await createVideoLink(this.videoId)
            this.linkLoading = false
            if (state === 200 && results) {
                this.linkName = results
            } else {
                this.$message({
                    message: '生成链接失败，请稍后再试',
                    customClass: 'hos-message--error',
                    iconClass: 'el-icon-error',
                    duration: '1000'
                })
            }
        },
        handleUpload () {
            // 打开文件选择框
            Bus.$emit('openUploader', {
                iuid: this.userInfo.iuid,
                hospitalId: this.userInfo.hospitalId,
                author: this.userInfo.accountName
            })
        },
        async queryList () {
            let createTimeStart = ''
            let createTimeEnd = ''
            if (this.selectForm.createTime) {
                createTimeStart = this.selectForm.createTime[0] + ' 00:00:00'
                createTimeEnd = this.selectForm.createTime[1] + ' 23:59:59'
            }
            let params = {
                videoNameOrId: this.selectForm.videoNameOrId,
                createTimeStart: createTimeStart,
                createTimeEnd: createTimeEnd,
                current: this.page.current,
                size: this.page.pageSize
            }
            this.loading = true
            this.dataList = []
            const { results, total } = await postVideoList(params)
            if (results.length > 0) {
                this.page.total = total
                this.dataList = results
            } else {
                if (this.page.current > 1) {
                    this.page.current -= 1
                    this.queryList()
                }
            }
            this.loading = false
        },
        init () {
            // 文件选择后的回调
            Bus.$on('fileAdded', () => {
                console.log('文件已选择')
            })

            // 文件上传成功的回调
            Bus.$on('fileSuccess', () => {
                console.log('文件上传成功')
                this.query(1)
            })

            this.queryList()
        }
    },
    mounted () {
        this.init()
    },
    destroyed () {
        Bus.$off('fileAdded')
        Bus.$off('fileSuccess')
    }
}
</script>

<style lang="scss">
.video-library-wrap {
    height: 100%;
    .video-library-content {
        height: calc(100% - 91px);
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        overflow: auto;
        .title-wrap {
            font-size: 0;
            height: 16px;
            line-height: 16px;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }

        .search-wrap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .option-wrap {
                display: flex;
                flex-wrap: wrap;
                &:last-child {
                    margin-bottom: 0;
                }
                .option-item {
                    display: inline-block;
                    font-size: 0;
                    margin: 20px 20px 20px 0;
                    .label {
                        padding-right: 10px;
                        font-size: 14px;
                        color: #666;
                        display: inline-block;
                        width: 56px;
                        text-align: right;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                    .el-select {
                        margin-right: 10px;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                    .el-input {
                        margin-right: 10px;
                        .el-input__inner {
                            height: 32px;
                        }
                    }
                    .el-date-editor {
                        margin-right: 10px;
                    }
                }
                .select-btn-wrap {
                    font-size: 0;
                    margin-top: 20px;
                    .el-button--small {
                        width: 80px;
                        padding: 8px 15px;
                        font-size: 14px;
                    }
                    .el-button--info.is-plain {
                        background: #f5f5f5;
                        border-color: #cccccc;
                        color: #666;
                    }
                }
            }
        }

        .table-wrap {
            .table-none {
                height: 400px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .icon {
                    font-size: 100px;
                }
                span {
                    line-height: 14px;
                }
            }
            .link-btn {
                color: $a-link;
                cursor: pointer;
                font-size: 12px;
                display: inline-block;
                height: 14px;
                line-height: 14px;
                border-right: 1px solid $a-link;
                margin-right: 6px;
                padding-right: 6px;
                &:last-child {
                    border-right: none;
                    margin-right: 0;
                    padding-right: 0;
                }
            }
        }
    }
}
.video-dialog {
    .el-dialog__header {
        padding: 0 !important;
        position: relative;
        .icon-delete {
            cursor: pointer;
            position: absolute;
            top: -20px;
            right: -20px;
            color: #999;
            width: 20px;
            height: 20px;
        }
    }
    .el-dialog__body {
        padding: 0 !important;
        height: 516px;
        .video-paly {
            border: none;
        }
    }
}
// 生成链接样式
.group-dialog {
    .el-dialog__body {
        display: flex;
        justify-content: center;
    }
    .el-form-item {
        margin-bottom: 24px;
        &.is-error {
            margin-bottom: 30px;
        }
    }
    .form-wrap {
        display: inline-block;
    }
    .dialog-btn-wrap {
        padding: 0 20px 24px 40px;
        text-align: left;
        .el-button {
            width: 96px;
            font-size: 14px;
        }
        .el-button--info.is-plain {
            background-color: #f5f5f5;
            border-color: #dbdbdb;
            color: #666;
        }
    }
    .link-loading {
        min-height: 56px;
    }
}
</style>
